<h2>About My Home</h2>

<h3>Home characteristics</h3>

<form class="usa-form">
  <label class="usa-label" for="input-floor-area">Floor area (square meters)</label>
  <input class="usa-input usa-input--small" type="number" id="input-floor-area" name="input-floor-area" [(ngModel)]="homeCharacteristics.floorArea">
  
  <label class="usa-label" for="input-year-built">Year built</label>
  <input class="usa-input usa-input--small" type="number" id="input-year-built" name="input-year-built" [(ngModel)]="homeCharacteristics.yearBuilt">
  
  <label class="usa-label" for="input-number-of-floors">Number of floors</label>
  <select class="usa-select" name="input-number-of-floors" id="input-number-of-floors" [(ngModel)]="homeCharacteristics.numberOfFloors">
    <option [value]="1">1</option>
    <option [value]="2">2</option>
    <option [value]="3">3</option>
  </select>
  
  <label class="usa-label" for="input-type-of-house">Type of house</label>
  <select class="usa-select" name="input-type-of-house" id="input-type-of-house" [(ngModel)]="homeCharacteristics.typeOfHouse" (change)="updateHouseType()">
    <option [value]="1">Single family building</option>
    <option [value]="2">Multi-family building</option>
  </select>
  
  <label class="usa-label" for="input-wind-shelter">Wind sheltering of house</label>
  <select class="usa-select" name="input-wind-shelter" id="input-wind-shelter" [(ngModel)]="homeCharacteristics.windShelteringOfHouse" [disabled]="homeCharacteristics.typeOfHouse == 2">
    <option [value]="1">No nearby structures</option>
    <option [value]="2">Isolated rural house</option>
    <option [value]="3">Other buildings across street​</option>
    <option [value]="4">Urban buildings on large lots</option>
    <option [value]="5">Other structures closer than 1 building height away</option>
  </select>
</form>

<h3>Home operating conditions</h3>

<form class="usa-form">
  <label class="usa-label" for="input-floor-temperature">Indoor temperature (&deg;C)</label>
  <input class="usa-input usa-input--small" type="number" id="input-floor-temperature" name="input-floor-temperature" [(ngModel)]="homeOperatingConditions.indoorTemperature">
  
  <h4>Windows</h4>
  
  <label class="usa-label" for="input-windows-open">Number of windows open</label>
  <input class="usa-input usa-input--small" type="number" id="input-windows-open" name="input-windows-open" [(ngModel)]="homeOperatingConditions.numberOfWindowsOpen">
  
  <label class="usa-label" for="input-window-height">Average opening height (cm)</label>
  <input class="usa-input usa-input--small" type="number" id="input-window-height" name="input-window-height" [(ngModel)]="homeOperatingConditions.openingHeightOfWindows">
  
  <label class="usa-label" for="input-window-duration">Duration windows open (hours)</label>
  <input class="usa-input usa-input--small" type="number" id="input-window-duration" name="input-window-duration"[(ngModel)]="homeOperatingConditions.durationWindowsOpen">
  
  <h4>Doors</h4>
  
  <label class="usa-label" for="input-doors-open">Number of doors open</label>
  <input class="usa-input usa-input--small" type="number" id="input-doors-open" name="input-doors-open" [(ngModel)]="homeOperatingConditions.numberOfDoorsOpen">
  
  <label class="usa-label" for="input-door-height">Average opening height (cm)</label>
  <input class="usa-input usa-input--small" type="number" id="input-door-height" name="input-door-height" [(ngModel)]="homeOperatingConditions.openingHeightOfDoors">
  
  <label class="usa-label" for="input-door-duration">Duration doors open (hours)</label>
  <input class="usa-input usa-input--small" type="number" id="input-door-duration" name="input-door-duration" [(ngModel)]="homeOperatingConditions.durationDoorsOpen">
  
  <h4>Window fans</h4>
  
  <label class="usa-label" for="input-window-fans">Number of window fans operating</label>
  <input class="usa-input usa-input--small" type="number" id="input-window-fans" name="input-window-fans" [(ngModel)]="homeOperatingConditions.numberOfWindowFansOperating">
  
  <label class="usa-label" for="input-fan-duration">Duration fans operating (hours)</label>
  <input class="usa-input usa-input--small" type="number" id="input-fan-duration" name="input-fan-duration" [(ngModel)]="homeOperatingConditions.durationWindowFansOperating">
  
  <h4>Air cleaners</h4>
  
  <label class="usa-label" for="input-air-cleaners">Number of air cleaners operating</label>
  <input class="usa-input usa-input--small" type="number" id="input-air-cleaners" name="input-air-cleaners" [(ngModel)]="homeOperatingConditions.numberOfAirCleanersOperating">
  
  <label class="usa-label" for="input-air-cleaner-duration">Duration cleaners operating (hours)</label>
  <input class="usa-input usa-input--small" type="number" id="input-air-cleaner-duration" name="input-air-cleaner-duration" [(ngModel)]="homeOperatingConditions.durationAirCleanersOperating">
</form>

<p>
  <button class="usa-button" type="button" (click)="save()">Save</button>
  <button class="usa-button usa-button--secondary" type="button" routerLink="/" skipLocationChange>Cancel</button>
</p>
